import { Link } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui'

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <div className="text-center animate-fade-in">
        <div className="text-8xl font-black text-slate-800 mb-4 select-none">404</div>
        <h1 className="text-xl font-bold text-slate-300 mb-2">Halaman tidak ditemukan</h1>
        <p className="text-sm text-slate-500 mb-8 max-w-xs mx-auto">
          Halaman yang Anda cari tidak ada atau telah dipindahkan.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/dashboard">
            <Button id="not-found-home" variant="primary" leftIcon={<Home size={14} />}>
              Ke Dashboard
            </Button>
          </Link>
          <Button
            id="not-found-back"
            variant="ghost"
            leftIcon={<ArrowLeft size={14} />}
            onClick={() => window.history.back()}
          >
            Kembali
          </Button>
        </div>
      </div>
    </div>
  )
}
